export default __webpack_public_path__ + "static/media/S3xSOLUTION.acbe1e62.jpg";